import Vue from 'vue'
import Vuex from 'vuex'
import api from "../api/index";
Vue.use(Vuex);
// 检查 sessionStorage 中是否存在标记
const isNewSession = sessionStorage.getItem('isNewSession') === null;
if (isNewSession) {
  // 标记会话已开始
  sessionStorage.setItem('isNewSession', 'false');
}
export default new Vuex.Store({
    state: {
        curtAct: null, //中文电脑端选中的底部导航index
        curtAct2: null, //中文手机端选中的底部导航index
        headAct: 0, //中文电脑端选中的头部导航index
        enAct1: 0,//英文电脑端选中的头部导航index
        useAge: 1,//1不知道多大，2已满18多，3小于18岁
        loadPage: true,
        kaiPing:1,//1不显示 2显示 3已经显示过了
        footList: [{
                title: "防伪查询",
                imgdeft: require("@/images/footer/fw1.png"),
                imgact: require("@/images/footer/fw2.png"),
                sel: false,
                path: '/seAll'
            },
            {
                title: "专卖店查询",
                imgdeft: require("@/images/footer/bt2.png"),
                imgact: require("@/images/footer/bt2_act.png"),
                sel: false,
                path: '/shop'
            },
            {
                title: "招商加盟",
                imgdeft: require("@/images/footer/bt3.png"),
                imgact: require("@/images/footer/bt3_act.png"),
                sel: false,
                path: '/join'
            },
            {
                title: "联系我们",
                imgdeft: require("@/images/footer/bt4.png"),
                imgact: require("@/images/footer/bt4_act.png"),
                sel: false,
                path: '/contact'
            },
            {
                title: "官方旗舰店",
                imgdeft: require("@/images/footer/bt5.png"),
                imgact: require("@/images/footer/bt5_act.png"),
                sel: false,
                path: ''
            },
            {
                title: "官方微信",
                imgdeft: require("@/images/footer/bt1.png"),
                imgact: require("@/images/footer/bt1_act.png"),
                sel: false,
                path: ''
            },
            {
                title: "人才招聘",
                imgdeft: require("@/images/footer/bt6.png"),
                imgact: require("@/images/footer/bt6_act.png"),
                sel: false,
                path: 'https://zhaopin.jncapp.cn/'
            },
        ],
        footList2: [{
                title: "防伪查询",
                img: require("@/images/phone/pbtm1.png"),
                sel: false,
                path: '/seAll'
            },
            {
                title: "招商加盟",
                img: require("@/images/phone/pbtm2.png"),
                sel: false,
                path: '/join'
            },
            {
                title: "联系我们",
                img: require("@/images/phone/pbtm3.png"),
                sel: false,
                path: '/contact'
            },
            {
                title: "人才招聘",
                img: require("@/images/phone/pbtm4.png"),
                sel: false,
                path: 'https://zhaopin.jncapp.cn/'
            },
            {
                title: "专卖店",
                img: require("@/images/phone/pbtm5.png"),
                sel: false,
                path: '/shopareas'
            },
        ],
        headList: [],
        headList2: [],//英文头部分类导航
        language: '',//1中文，2英文  防止页面刷新时不在当前页面
    },
    mutations: {
        // 中文头部分类导航
        GETHEADLIST(state, dataList) {
            state.headList = dataList;
        },
        // 英文头部分类导航
        GETHEADLISTEN(state, dataList) {
            state.headList2 = dataList;
        },
        GETLAN(state, data) {
            if(state.language==''){
                state.language = data;
            }
        },
        SET_CURRENT_TAB(state, index) {
            state.curtAct = index;
        },
        SET_CURRENT_TAB2(state, index) {
            state.curtAct2 = index;
        },
        HEAD_NAV(state, index){
            state.headAct = index;
        },
        HEAD_NAVEN(state, index){
            state.enAct1 = index;
        }
    },
    actions: {
        // 中文头部分类导航
        async getHeadList({commit}) {
            const res = await api.indexCate();
            const data1=res.data;
            for(let i=0;i<data1.length;i++){
                for(let j=0;j<data1[i].zicate.length;j++){
                    data1[i].zicate[j].images2=data1[i].zicate[j].images.split(',');
                    data1[i].zicate[j].sel=1;
                }
            }
            if(res.code == 1){
                commit('GETHEADLIST',data1);
            }
        },
        // 英文头部分类导航
        async getHeadList2({commit}) {
            const res = await api.enIndex();
            const data1=res.data;
            if(res.code == 1){
                commit('GETHEADLISTEN',data1);
            }
        },
        // 获取中英文
        async getLan({commit}) {
            const res = await api.nowClientIP();
            // console.log('语言',res)
            if(res.msg == '国内'){
                commit('GETLAN',1);
            }else{
                commit('GETLAN',2);
            }
        },
        // 中文电脑端头部导航
        changeNav({commit}, index) {
            commit('HEAD_NAV', index);
        },
        // 中文电脑端底部导航
        changeTab({commit}, index) {
            commit('SET_CURRENT_TAB', index);
        },
        // 中文手机端底部导航
        changeTab2({ commit }, index) {
            commit('SET_CURRENT_TAB2', index);
        },
        // 英文电脑端顶部导航
        changeNav2({commit}, index) {
            commit('HEAD_NAVEN', index);
        },
    },
})